import { React, PT } from '@gasbuddy/react';
import { Modal } from '@gasbuddy/react-components';
import ReactMarkdown from 'react-markdown';

export default function CategoryDetail({ category, onClose }) {
  return (
    <Modal
      content={<div style={{ minHeight: '80vh' }}><ReactMarkdown>{category.detail}</ReactMarkdown></div>}
      forceIsShowing
      onClose={onClose}
    />
  );
}

CategoryDetail.propTypes = {
  category: PT.shape({
    detail: PT.string,
  }).isRequired,
  onClose: PT.func.isRequired,
};
